import { render, staticRenderFns } from "./Subestoque.vue?vue&type=template&id=3f89fcfa"
import script from "./Subestoque.vue?vue&type=script&lang=js"
export * from "./Subestoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports